module.exports = __webpack_public_path__ + "static/media/scheme7.9ef2613a.png";